import { Reducer } from "redux";

import { DisciplineDetailsResponse } from "../models/Api/DisciplineDetails";
import { DisciplineDetailsDispatchTypes } from "../models/DispatchTypes/DesciplineDetails";
import { DisciplineDetailsActionDispatchTypes } from "../constants/Disciplines";

const initialState: DisciplineDetailsResponse = {
  loading: false,
  response: {
    serviceRequestDisciplineId: -1,
    requestDateTime: "",
    serviceRequestTypeName: "",
    disciplineName: "",
    urgencyStatus: "",
    requestedVisits: 0,
    approvedVisits: 0,
    deniedVisits: 0,
    serviceStatus: "",
    serviceStatusReason: "",
    receivedMethodName: "",
    effectiveFromDate: "",
    effectiveThroughDate: "",
    dateCreated: "",
    createdBy: "null",
    decidedBy: "",
    decidedDateTime: "",
    rationale: "",
    resourceDescription: "",
    otherRationale: "",
    otherResourceDescription: "",
    medicaidRationale: "",
    otherMedicaidRationale: "",
    requestedBy: "",
  },
  error: null,
};

const GetDisciplineDetailsReducer: Reducer<
  DisciplineDetailsResponse,
  DisciplineDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DisciplineDetailsActionDispatchTypes.GET_DISCIPLINE_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DisciplineDetailsActionDispatchTypes.GET_DISCIPLINE_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DisciplineDetailsActionDispatchTypes.GET_DISCIPLINE_DETAILS_ERROR: {
      return {
        ...state,
        loading: false,
       error: action.error,
      };
    }
    case DisciplineDetailsActionDispatchTypes.GET_DISCIPLINE_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GetDisciplineDetailsReducer;
